import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import managementIllustration from "../../../../assests/management/managementIllustration.png";

const ManagementCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#f6f6f6"
            title={texts.virtualSchoolManagement}
            image={managementIllustration}
            imageAlt={texts.virtualSchoolManagement}
            link={`/${pathRouts.MANAGERDASHBOARD}/${pathRouts.LOGOANDIMAGE}`}
        />
    );
};

export default ManagementCarouselWidget;
